import { StackedColumnComponent } from '../charts/stacked-column-chart-component'
import { TRANSFORM_EXCLUDE_KEY } from '../commons/constants'

export class AFSentimentBySource extends StackedColumnComponent {
    static config = {
        selector: 'afSentimentBySource',
        controller: AFSentimentBySource,
        bindings: StackedColumnComponent.config.bindings,
        template: StackedColumnComponent.config.template,
    }

    setProperties() {
        this.seriesColors = this.colorUtils.setColorPalette(this.buildChartData(this.vizData.data))
        this.transformationProfiles = [{
            key: 'code', type: TRANSFORM_EXCLUDE_KEY
        }]
    }
}
